import React from 'react';
import { TableHead } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS } from 'utils/constants/dashboard';

type RequestDrillDownTableHeaderProps = {
  handleSort: (column: string) => void;
};

const RequestDrillDownTableHeader: React.FC<
  RequestDrillDownTableHeaderProps
> = ({ handleSort }) => {
  const headCells = [
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.REQUEST_NUMBER,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.REQUEST_NUMBER'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.REQUEST_TITLE,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.REQUEST_TITLE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.STATUS,
      content: intl.get('DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.STATUS'),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TYPE,
      content: intl.get('DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.TYPE'),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.REQUESTER_NAME,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.REQUESTER_NAME'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.REQUEST_OWNER,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.REQUEST_OWNER'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECTS,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.PROJECTS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.BUSINESS_UNIT,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.BUSINESS_UNIT'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.INTERNAL_PRIORITY,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.INTERNAL_PRIORITY'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.FORM_USED,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.FORM_USED'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.CREATION_DATE,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.CREATION_DATE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.SUBMISSION_DATE,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.SUBMISSION_DATE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.DECISION_DATE,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.DECISION_DATE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: REQUEST_DRILLDOWN_TABLE_SORTABLE_COLUMNS.LAST_UPDATE,
      content: intl.get(
        'DASHBOARDS_REQUEST_DRILLDOWN_PAGE.TABLE.HEAD.LAST_UPDATE'
      ),
    },
  ];

  return (
    <TableHead stickyHeader handleSort={handleSort} headCells={headCells} />
  );
};

export default RequestDrillDownTableHeader;
